<div [formGroup]="form">
  <div class="form-group">
    <app-shareholder-with-nbo-sign
      [formGroup]="form.controls.shareholder"
      [securityRegistryRecords]="securityRegistryRecords"
      (select)="onSelectCurrentShareholder($event)"
  />
  </div>

  <app-divider margin="24px 0"/>

  <div class="form-group">
    <div class="form-group share-types">
      <app-share-security-holdings-dropdown
        formControlName="securityHoldingId"
        [options]="securityRegistryRecordsHoldings"
      />
    </div>
  </div>

  <div class="share-numbers-grid">
    <div class="form-group">
      <app-input-number
        label="Number of shares to be transferred"
        formControlName="numberIncrease"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.number ?? 0"
      />
    </div>

    <div class="form-group total-consideration-paid">
      <app-input-number
        label="Consideration Paid"
        formControlName="considerationPaid"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
     />
    </div>

    <div class="form-group total-paid">
      <app-input-number
        label="Total Amount Paid"
        formControlName="paidIncrease"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.paid ?? 0"
      />
    </div>

    <div class="form-group total-unpaid">
      <app-input-number
        label="Total Amount Unpaid"
        formControlName="unpaidIncrease"
        [customErrors]="totalNumberOfSharesCustomErrors"
        [min]="0"
        [max]="this.selectedShareholderShareType?.unpaid ?? 0"
     />
    </div>
  </div>

  <div class="form-group" [hidden]="formShareNumberErrorMessageHidden">
    <app-validation-error
      [control]="form"
      [customErrors]="customErrorsOfShareCancellationNumbers"
  />
  </div>
</div>
